var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Chevron_Right",
    d: "M7.76794 5.57172L1.43923 0.177144C1.16154 -0.0590471 0.711617 -0.059047 0.433216 0.177144C0.155517 0.413336 0.155517 0.796971 0.433216 1.03316L6.25994 5.9997L0.433919 10.9662C0.156219 11.2024 0.156219 11.5861 0.433919 11.8229C0.711618 12.059 1.16224 12.059 1.43994 11.8229L7.76864 6.42833C8.04208 6.19458 8.04208 5.80492 7.76794 5.57172Z",
    fill: "#05275D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.aaf77ebb685872a1d83d0c8959ec3a4a.svg";
export { ForwardRef as ReactComponent };